import { SimpleGrid, Button, SimpleGridProps } from "@chakra-ui/react";
import { THEME_COLOR_SCHEME } from "./theme";

interface YearSelectorProps extends SimpleGridProps {
  year: number | null;
  setYear: (year: number | null) => void;
}

export const YearSelector = ({
  year,
  setYear,
  ...simpleGridProps
}: YearSelectorProps) => {
  return (
    <SimpleGrid
      minChildWidth={"120px"}
      spacing={2}
      marginTop={4}
      marginBottom={4}
      {...simpleGridProps}
    >
      {[7, 8, 9, 10, 11, 12].map((i) => (
        <Button
          key={i}
          onClick={() => (year === i ? setYear(null) : setYear(i))}
          variant={i === year ? undefined : "outline"}
          colorScheme={i === year ? THEME_COLOR_SCHEME : undefined}
        >
          Year {i}
        </Button>
      ))}
    </SimpleGrid>
  );
};
